import { Component, Input } from '@angular/core';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { Seat } from '../../models/team/seat';
import { ActivatedRoute } from '@angular/router';
import { GenericAttributeServiceFactory } from '../../services/genericAttributeServiceFactory.service';
import { IGenericAttributeService } from 'src/shared-app-portal/interfaces/i-generic-attribute-service';

@Component({
  selector: 'profile-custom-field',
  templateUrl: './profile-custom-field.component.html',
  styleUrls: ['./profile-custom-field.component.scss'],
  standalone: false
})
export class ProfileCustomFieldComponent {
  @Input() showEmpty: boolean = true;
  @Input() customFields: AttributeDefinition[];
  @Input() customFieldValues: Attribute[];
  /**optional. Only required if editing team fields */
  @Input() seat: Seat;
  constructor(
    private route: ActivatedRoute,
    private genericAttributeServiceFactory: GenericAttributeServiceFactory
  ) {}

  public getCustomFieldValueByTypeId(attributeDefinitionId: string): Array<Attribute> {
    return this.customFieldValues?.filter((a) => a.attributeDefinitionId == attributeDefinitionId);
  }
  public isEmpty = (attributeDefinition: AttributeDefinition) => {
    if (!this.customFieldValues) {
      return true;
    }
    return !this.customFieldValues.find((a) => a.attributeDefinitionId == attributeDefinition.id);
  };

  buildGenericPersonAttributeService = (
    customField: AttributeDefinition
  ): IGenericAttributeService => {
    if (this.seat) {
      return this.genericAttributeServiceFactory.BuildForTeamProfile(
        this.route.snapshot.params['teamId'],
        customField,
        this.seat
      );
    }

    const personId = this.route.parent.snapshot.params['personId'];
    if (personId) {
      return this.genericAttributeServiceFactory.BuildForPersonOnProfile(personId, customField);
    }
    const teamId = this.route.parent.snapshot.params['teamId'];
    if (teamId)
      return this.genericAttributeServiceFactory.BuildForTeamWithoutSeatOnProfile(
        teamId,
        customField
      );
    throw new Error('Cannot build GenericAttributeService. Need teamId, personId, or seat.');
  };
}
